import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from "react";
const SvgArrowLeftWhite = (props, ref) => (_jsx("svg", { width: 17, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: _jsx("path", { d: "M12.6663 7.99992H3.33301M3.33301 7.99992L7.99967 12.6666M3.33301 7.99992L7.99967 3.33325", stroke: "white", strokeWidth: 1.33333, strokeLinecap: "round", strokeLinejoin: "round" }) }));
const ForwardRef = forwardRef(SvgArrowLeftWhite);
export default ForwardRef;
